export const gcpRegion = 'europe-west1'

export function flavorToAppEnv(flavor: string): string {
  switch (flavor) {
    case 'debug':
      return 'test'
    case 'staging':
      return 'stage'
    case 'release':
      return 'prod'
    case 'research':
      return 'prod'
    case 'experimental':
      return 'stage'
    default:
      return flavor // Already env
  }
}
